import axios from 'axios';
import { err, ok } from 'neverthrow';
import { defaultConfig } from './config/DefaultConfig';
import { defaultServerConfig } from './config/DefaultServerConfig';
export const config = (() => {
    const _config = defaultConfig;
    const _cachedServerconfig = defaultServerConfig;
    let _cachedUrl = parseCachedUrl(_config);
    function set(config) {
        config = validatePropsConfig(config);
        Object.keys(config).forEach((value, key) => {
            _config[value] = config[value];
        });
        _cachedUrl = parseCachedUrl(_config);
    }
    function parseCachedUrl(config) {
        if (config.url !== '') {
            return `${config.secure ? `https://` : `http://`}${config.url}${[443, 80, undefined].indexOf(config.port) > -1 ? `:${config.port}` : ``}${config.path}`;
        }
        else if (config.url === '' && config.path) {
            return config.path;
        }
        return '';
    }
    function get() {
        return _config;
    }
    function cachedUrl() {
        return _cachedUrl;
    }
    function validatePropsConfig(config) {
        const _config = { ...defaultConfig, ...config }; //clone
        if (_config.url && _config.url.substr(-1) === '/') {
            _config.url = _config.url.substr(0, -2);
        }
        _config.secure =
            _config.url.substr(0, 8) === 'https://' ||
                _config.port === 443 ||
                _config.secure;
        if (_config.path) {
            let parts = _config.path.split('/');
            if (parts[0] !== '') {
                parts.unshift('');
            }
            if (parts[parts.length - 1] === '') {
                parts.pop();
            }
            _config.path = parts.join('/');
        }
        else {
            _config.path = '/';
        }
        return _config;
    }
    async function readServerConfig(token) {
        if (_cachedServerconfig.version !== 'default') {
            return ok(_cachedServerconfig);
        }
        try {
            const requestConfig = token
                ? {
                    headers: { Authorization: `Bearer ${token}` },
                }
                : undefined;
            const result = await axios.get(`${_cachedUrl}/config`, requestConfig);
            if (result && result.status === 200) {
                let copyObject = result.data;
                Object.keys(copyObject).forEach((value, key) => {
                    _cachedServerconfig[value] = copyObject[value];
                });
                return ok(_cachedServerconfig);
            }
            else if (result && result.status === 401) {
                return ok(_cachedServerconfig); //not allowed.. return default!
            }
            return err(result.data);
        }
        catch (error) {
            if (error && error.status === 401) {
                return ok(_cachedServerconfig); //not allowed.. return default!
            }
            return err(error.response.data);
        }
    }
    async function setServerConfig(config) {
        const { auth_keypair_public, version, ...requestBody } = config; //remove ready only props
        try {
            const result = await axios.put(`${_cachedUrl}/config`, requestBody);
            if (result && result.status === 200) {
                Object.keys(requestBody).forEach((value, key) => {
                    _cachedServerconfig[value] = requestBody[value];
                });
                return ok(_cachedServerconfig);
            }
            return err(result.data);
        }
        catch (error) {
            return err(error.response.data);
        }
    }
    return {
        set: set,
        get: get,
        fullUrl: cachedUrl,
        server: readServerConfig,
        serverSet: setServerConfig,
    };
})();
